<template>
	<el-tooltip :content="str" :disabled="isShowTooltip" effect="dark" placement="top">
		<div @mouseover="onMouseOver(str)" style="overflow: hidden;  text-overflow: ellipsis; white-space: nowrap;">
			<span :ref="str">{{`${str}`}}</span>
		</div>
	</el-tooltip>
</template>

<script>
export default {
	name: 'OverTooltip',
	props: {
		str: {
			type: String
		}
	},
	data () {
		return {
			isShowTooltip: false
		}
	},

	methods: {
		onMouseOver (str) { // 内容超出，显示文字提示内容
			const tag = this.$refs[str]
			const parentWidth = tag.parentNode.offsetWidth // 获取元素父级可视宽度
			const contentWidth = tag.offsetWidth // 获取元素可视宽度
			this.isShowTooltip = contentWidth <= parentWidth

		}
	}

}
</script>

<style>
</style>